import withRAF from '@hoc/withRAF'

import GLManager from '@components/GLManager'

/**
 * Link between DOM and WebGL.
 */
export default withRAF({
  name: 'webgl',

  componentDidMount () {
    this.manager = new GLManager({
      canvas: this.el,
    })
  },

  update (t) {
    if (this.manager) this.manager.update(t)
  },
})
